import { useQuery } from '@tanstack/react-query';

import { threeDModelFetcher } from '../../fetchers/3d-model-fetchers';

type Props = {
  data: Data;
  isLoading: boolean | undefined;
  error: any;
  isFetching: boolean;
  isFetched: boolean;
};
const useGet3DModels = ({
  batchId,
  subjectId,
  scheduleId,
}: {
  batchId: string;
  subjectId: string;
  scheduleId: string;
}): Props => {
  const { data, isLoading, error, isFetching, isFetched, refetch } = useQuery(
    ['3d-models', { batchId, subjectId, scheduleId }],
    threeDModelFetcher,
    {
      retry: false,
      refetchOnWindowFocus: false,
      enabled: !!batchId && !!subjectId && !!scheduleId,
    },
  );
  return {
    ...(data?.data && { data: new Data(data?.data) }),
    isLoading,
    error,
    isFetching,
    isFetched,
  };
};
export class Data {
  _id: string;
  scheduleId: string;
  scheduleIds: string;
  models: Model[];
  constructor(data: any) {
    data = data || {};
    this._id = data._id || '';
    this.scheduleId = data.scheduleId || '';
    this.scheduleIds = data.scheduleIds || '';
    if (data?.models) {
      this.models = data.models.map((res: any) => new Model(res));
    } else {
      this.models = [];
    }
  }
}

export class Model {
  _id: string;
  url: string;
  thumbImageUrl: string;
  name: string;
  type: string;
  htmlUrl: string;
  isSlidemakerAsset: boolean;
  constructor(data: any) {
    data = data || {};
    this._id = data._id || '';
    this.url = data.url || '';
    this.thumbImageUrl = data.thumbImageUrl || '';
    this.name = data.name || '';
    this.type = data.type || '';
    this.htmlUrl = data.htmlUrl || '';
    this.isSlidemakerAsset = data.isSlidemakerAsset || '';
  }
}

export class ThumbImage {
  _id: string;
  baseUrl: string;
  key: string;
  constructor(data: any) {
    data = data || {};
    this._id = data._id || '';
    this.baseUrl = data.baseUrl || '';
    this.key = data.key || '';
  }
}
export default useGet3DModels;
